import { render, staticRenderFns } from "./SparesForm.vue?vue&type=template&id=868e6aac"
import script from "./SparesForm.js?vue&type=script&lang=js&external"
export * from "./SparesForm.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports